import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { EventLoggerService } from '@services/event-logger-service';
import { AppConfig } from 'client/app/app.config';

export interface DeletePhotoSheetData {
  hideNewPhotoOption?: boolean;
  clickNewPhotoCallback?: () => void;
  deleteCallback?: () => void;
}

@Component({
  selector: 'delete-photo-sheet',
  templateUrl: './delete-photo-sheet.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DeletePhotoSheetComponent {
  protected readonly data = inject<DeletePhotoSheetData>(MAT_BOTTOM_SHEET_DATA);
  private readonly appConfig = inject(AppConfig);
  private readonly bottomSheetRef = inject(MatBottomSheetRef);
  private readonly eventLogger = inject(EventLoggerService);

  takeNewPhoto(): void {
    if (this.data?.clickNewPhotoCallback) this.data.clickNewPhotoCallback();
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'delete-checkup-photo-pupup-take-new-photo' }));
    this.bottomSheetRef.dismiss();
  }

  closedPopup(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'delete-checkup-photo-pupup-close' }), [
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.MOENGAGE,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
    this.bottomSheetRef.dismiss();
  }

  deleteCurrentPhoto(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'delete-checkup-photo-pupup-delete-photo' }));
    if (this.data?.deleteCallback) this.data.deleteCallback();
    this.bottomSheetRef.dismiss();
  }
}
